/**
 * The response envelope every SIPAY endpoint returns.
 *
 * Kept identical in shape to what snap-api and MINT already use, so the codes
 * are the ones the team already knows. Two additions: a `traceId` for support,
 * and `fieldErrors` so validation failures land on the right form field
 * instead of in a toast.
 */

export const RES = {
  OK: '00',
  BAD_REQUEST: '01',
  SAVE_FAILED: '02',
  PARSE_FAILED: '03',
  NOT_FOUND: '04',
  DUPLICATE: '05',
  ACCESS_DENIED: '06',
  INTERNAL: '07',
  // SIPAY workflow range
  INVALID_TRANSITION: '10',
  NOT_AN_APPROVER: '11',
  NO_APPROVAL_MATRIX: '12',
  ERP_POST_FAILED: '13',
  ATTACHMENT_REJECTED: '14',
  CONCURRENT_MODIFICATION: '15',
} as const

export interface ApiEnvelope<T> {
  resCd: string
  resMsg: string
  resObj: T | null
  fieldErrors?: Record<string, string> | null
  traceId?: string | null
}

export class ApiError extends Error {
  constructor(
    readonly resCd: string,
    readonly resMsg: string,
    readonly httpStatus: number,
    readonly fieldErrors?: Record<string, string> | null,
    readonly traceId?: string | null,
  ) {
    super(resMsg || `Kesalahan API ${resCd}`)
    this.name = 'ApiError'
  }

  get isAuth() {
    return this.httpStatus === 401
  }

  get isForbidden() {
    return this.httpStatus === 403 && this.resCd !== RES.ACCESS_DENIED
  }

  get isConflict() {
    return this.httpStatus === 409
  }

  get isNotFound() {
    return this.httpStatus === 404 || this.resCd === RES.NOT_FOUND
  }

  /** True when the server rejected specific fields rather than the request as a whole. */
  get hasFieldErrors() {
    return !!this.fieldErrors && Object.keys(this.fieldErrors).length > 0
  }
}
